<template>
  <div>
    <notifications group="foo" />
    <!--begin::Content header-->
    <div
      class="
        position-absolute
        top-0
        right-0
        text-right
        mt-5
        mb-15 mb-lg-0
        flex-column-auto
        justify-content-center
        py-5
        px-10
      "
    ></div>
    <!--end::Content header-->

    <!--begin::Signin-->
    <div class="login-form login-signin" style="min-width: 350px">
      <div class="text-center mb-0 mt-lg-0">
        <img
          class="mb-5"
          src="media/logos/logo-hd-blanc.png"
          style="width: 300px"
        />
        <h3 class="font-size-h1">Connexion</h3>
        <p class="text-muted font-weight-semi-bold">
          Entrez votre email et votre mot de passe
        </p>
      </div>

      <!--begin::Form-->
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div
          role="alert"
          v-bind:class="{ show: errors.length }"
          class="alert fade alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>

        <b-form-group
          id="example-input-group-1"
          label=""
          label-for="example-input-1"
        >
          <b-form-input
            placeholder="Email"
            class="form-control form-control-solid h-auto py-5 px-6"
            id="example-input-1"
            name="example-input-1"
            v-model="$v.form.email.$model"
            :state="validateState('email')"
            aria-describedby="input-1-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">
            Un email est requis et une adresse e-mail valide.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="example-input-group-2"
          label=""
          label-for="example-input-2"
        >
          <b-form-input
            placeholder="Mot de passe"
            class="form-control form-control-solid h-auto py-5 px-6"
            type="password"
            id="example-input-2"
            name="example-input-2"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">
            Mot de passe requis.
          </b-form-invalid-feedback>
        </b-form-group>

        <!--begin::Action-->
        <div
          class="
            form-group
            d-flex
            flex-wrap
            justify-content-between
            align-items-center
          "
        >
          <!-- <router-link
            to="/forgotpassword"
            class="text-dark-60 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
            Mot de passe oublié ?
          </router-link> -->
          <button
            ref="kt_login_signin_submit"
            class="
              btn btn-primary btn-block
              font-weight-bold
              px-9
              py-4
              my-3
              font-size-3
            "
          >
            Se connecter
          </button>
        </div>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    </div>
    <!--end::Signin-->
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
//import { mapState } from "vuex";
import { LOGIN } from "@/core/services/store/auth.module";

//import { SELECT_PHARMACY } from "../../../core/services/store/pharmacy.module";

//import UserService from "../../../services/user.service";

import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      errors: [],
      form: {
        email: "",
        password: "",
      },
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;

      // clear existing errors
      //this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      this.$notify({
        group: "foo",
        clean: true,
      });
      // send login request
      this.$store
        .dispatch(LOGIN, { email, password })
        .then((data) => {
          switch (data.state) {
            case 1:
              this.$router.push("/");
              break;
            case 2:
              this.$notify({
                group: "foo",
                title: "Inforamtion",
                text: "Nom d'utilisateur ou mot de passe incorrect",
                type: "info",
              });
              break;
            case 5:
              this.$notify({
                group: "foo",
                title: "Erreur",
                text: "Une erreur s'est produite!",
                type: "danger",
              });
              break;
            default:
            // code block
          }

          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        })
        .catch(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );

          this.$notify({
            group: "foo",
            title: "Erreur",
            text: "Une erreur s'est produite!",
            type: "error",
          });
        });
    },
  },
  computed: {
    // ...mapState({
    //   errors: (state) => state.auth.errors,
    // }),
  },
};
</script>
